import { render, staticRenderFns } from "./IllustrationPhotosSection.vue?vue&type=template&id=f3e0d6a4"
import script from "./IllustrationPhotosSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationPhotosSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationPhotosSection.vue?vue&type=style&index=0&id=f3e0d6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports